<nb-auth-block>
  <h2 class="title">Reset Login Password</h2>
  <small class="form-text sub-title">We have sent a confirmation email to your registered email address. Please follow
    the instructions in the email to continue.
  </small>
  <hr>
  <h3>If you haven`t received the email, please try the following:</h3>
  <ul>
    <li>Check your spam or junk mail folders</li>
    <li>Make sure your email client is functioning normally</li>
  </ul>
  <!--<button type="button" class="btn btn-block btn-hero-success">Login</button>-->
  <a class="btn btn-block btn-hero-success" routerLink="#/auth/login"><strong>Login</strong></a>
</nb-auth-block>



// WEBPACK FOOTER //
// ./src/app/pages-crypto/components-crypto/forgot-password-message-crypto/forgot-password-message-crypto.component.html